import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { McbWindowComponent } from './mcb-window.component';
import { WindowModule as KendoWindowModule } from '@progress/kendo-angular-dialog';

@NgModule({
  declarations: [
    McbWindowComponent
  ],
  imports: [
    CommonModule,
    KendoWindowModule
  ],
  exports: [
    McbWindowComponent
  ]
})
export class WindowModule { }
